import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

export type SoActionBarMessageType = 'danger' | 'warning' | 'info' | 'success';

const MESSAGE_ICONS: Record<SoActionBarMessageType, string> = {
    danger: 'error_outline',
    warning: 'warning_amber',
    info: 'info',
    success: 'check_circle'
};

@Component({
    selector: 'so-action-bar-ui',
    standalone: true,
    imports: [CommonModule, MatIconModule],
    templateUrl: './so-action-bar.component.html',
    styleUrl: './so-action-bar.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SoActionBarUI {
    message = input<string>('');
    messageType = input<SoActionBarMessageType>('danger');
    showTopCorners = input<boolean>(true);
    height = input<number>(52);

    protected messageIcon = computed(() => MESSAGE_ICONS[this.messageType()]);
}
